import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import { XXLargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import withRefetchConsumer from '~/modules/core/utils/relayHelpers/withRefetchConsumer';
import PaginationBox from '~/modules/coreUI/components/pagination/PaginationBox';

import ItemsListView from './ItemsListView';
import SortAndChangeCardsView from './SortAndChangeCardsView';
import TracksFilter from './itemsListFilter/TracksFilter';
import ItemsListSpinner from './ItemsListSpinner';

const ContentWrapper = styled.div`
  flex-grow: 1;
  width: 80%;
`;

const isAnyFilterSelected = refetchVariables => refetchVariables
  && refetchVariables.input
  && refetchVariables.input.filter
  && refetchVariables.input.filter.length > 0;

const ItemsListSection = ({
  isProduct,
  isVariant,
  itemsList,
  pinnedProducts,
  showCardViewChangers,
  filters,
  isLoading,
  refetchVariables,
  isVertical,
  changeView,
  showFilterDropdown,
  searchString,
  vendorInfo,
  isVendorProduct,
  categorizeItemsList,
}) => {
  const changeCardsView = (value) => {
    changeView(value);
  };
  return (
    <ContentWrapper>
      <SortAndChangeCardsView
        changeView={changeCardsView}
        isVertical={isVertical}
        showCardViewChangers={showCardViewChangers}
        filters={filters}
        showFilterDropdown={showFilterDropdown}
      />
      <TracksFilter filters={filters} showFilterDropdown={showFilterDropdown} />
      {isLoading ? (
        <ItemsListSpinner vertical={isVertical} />
      ) : (
        <React.Fragment>
          {!isAnyFilterSelected(refetchVariables) && pinnedProducts}
          <ItemsListView
            isVariant={isVariant}
            isProduct={isProduct}
            isVertical={isVertical}
            itemsList={itemsList}
            isLoading={isLoading}
            searchString={searchString}
            isVendorProduct={isVendorProduct}
            vendorInfo={vendorInfo}
            categorizeItemsList={categorizeItemsList}
          />
          <PaginationBox />
          <XXLargeSpacer />
        </React.Fragment>
      )}
    </ContentWrapper>
  );
};
ItemsListSection.propTypes = {
  itemsList: PropTypes.arrayOf(PropTypes.shape({})),
  categorizeItemsList: PropTypes.arrayOf(PropTypes.shape({})),
  filters: PropTypes.instanceOf(Array),
  pinnedProducts: PropTypes.element,
  showCardViewChangers: PropTypes.bool,
  refetchVariables: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isProduct: PropTypes.bool,
  isVariant: PropTypes.bool,
  isVertical: PropTypes.bool,
  showFilterDropdown: PropTypes.bool,
  changeView: PropTypes.func.isRequired,
  isVendorProduct: PropTypes.bool,
  searchString: PropTypes.string,
  vendorInfo: PropTypes.shape({
    vendorID: PropTypes.string,
    vendorName: PropTypes.string,
  }),
};

ItemsListSection.defaultProps = {
  pinnedProducts: null,
  showCardViewChangers: false,
  isProduct: false,
  isVariant: false,
  isVertical: true,
  showFilterDropdown: false,
  filters: null,
  searchString: null,
  isVendorProduct: false,
  vendorInfo: {},
  itemsList: [],
  categorizeItemsList: [],
};
export default withRefetchConsumer(ItemsListSection);
